export default __webpack_public_path__ + "static/media/spinner.64b6e66a.svg";